import Main from "./components/Main";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";

import "./index.css";

function App() {
  return (
    <>
      <div className="w-full h-full overflow-hidden transition-colors duration-500 dark:bg-body dark:text-text bg-slate-100">
        <div className="max-w-[1200px] w-full mx-auto relative">
          <Navbar />
          <Main />
          <Projects />
        </div>
      </div>
    </>
  );
}

export default App;
